import { DeviceFrontEndInfo } from 'common';

export const getDeviceInfoUtil = (): DeviceFrontEndInfo => {
  return {
    screen: window?.screen?.width && window?.screen?.height ? `${window.screen.width}x${window.screen.height}` : 'unknown',
    timezone: (() => {
      try {
        return Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone || 'unknown';
      } catch {
        return 'unknown';
      }
    })(),
    language: navigator?.language || 'unknown',
    cookieEnabled: navigator?.cookieEnabled ?? false,
    onlineStatus: navigator?.onLine ? 'online' : 'offline',
    colorDepth: window?.screen?.colorDepth || 0,
    pixelRatio: window?.devicePixelRatio || 1,
    touchSupport: (() => {
      try {
        return window?.matchMedia?.('(hover: none)')?.matches || false;
      } catch {
        return false;
      }
    })(),
  };
};
